import { fromJS } from 'immutable';

import { START, SUCCESS, ERROR } from '@modules/appraisalAdmin/actions/global';
import * as actions from '../../actions/maintenance/users';
import { fetchingState, initialFilterValues } from '../../constants';

const initialStats = {
  users: {},
  filters: initialFilterValues,
  filteredUsers: {},
  modules: {},
  roles: {},
  taxingUnits: {},
  userTaxingUnits: {},
  searchCriteria: {},
  allTaxingUnits: {},
  userAttributeAssocs: {},
  systemAttributes: {},
  pageFilters: {
    page: 1,
    pageSize: 50,
  },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    // Users actions
    // ////////////
    case actions.USERS_FETCH_START:
      return state.setIn(['users', 'state'], fetchingState.FETCHING);
    case actions.USERS_FETCH_SUCCESS:
      let newState = state.setIn(['users', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['users', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.USERS_FETCH_ERROR:
      return state.setIn(['users', 'state'], fetchingState.ERROR);

    case actions.USER_INACTIVATE_SUCCESS:
      let newUsersList = state.getIn(['users', 'data'])
        ? state.getIn(['users', 'data']).toJS()
        : [];
      newUsersList = newUsersList.map((user) => {
        if (user.id === action.userId) {
          return action.data.results[0];
        }
        return user;
      });
      newState = state.setIn(['modules', 'data'], fromJS([]));
      newState = newState.setIn(['roles', 'data'], fromJS([]));
      return newState.setIn(['users', 'data'], fromJS(newUsersList));

    case actions.USER_ACTIVATE_SUCCESS:
      newUsersList = state.getIn(['users', 'data'])
        ? state.getIn(['users', 'data']).toJS()
        : [];
      newUsersList = newUsersList.map((user) => {
        if (user.id === action.userId) {
          return action.data.results[0];
        }
        return user;
      });
      return state.setIn(['users', 'data'], fromJS(newUsersList));

    case actions.USER_MODULES_FETCH_START:
      return state.setIn(['modules', 'state'], fetchingState.FETCHING);
    case actions.USER_MODULES_FETCH_SUCCESS:
      newState = state.setIn(['modules', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['modules', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.USER_MODULES_FETCH_ERROR:
      return state.setIn(['modules', 'state'], fetchingState.ERROR);

    case actions.USER_MODULE_ASSIGN_SUCCESS:
      let newUserModules = state.getIn(['modules', 'data']).toJS();
      newUserModules = newUserModules.concat([action.module]);
      newUsersList = state.getIn(['users', 'data']).toJS();
      newUsersList = newUsersList.map((user) => {
        if (user.id.toString() === action.userId) {
          const newModules = user.modules ? user.modules : [];
          return {
            ...user,
            modules: newModules.concat([
              { module: action.module.module, moduleID: action.module.id },
            ]),
          };
        }
        return user;
      });
      newState = state.setIn(['users', 'data'], fromJS(newUsersList));
      return newState.setIn(['modules', 'data'], fromJS(newUserModules));

    case actions.USER_MODULE_DELETE_SUCCESS:
      newUserModules = state.getIn(['modules', 'data']).toJS();
      newUserModules = newUserModules.filter(
        (module) => module.id !== action.moduleId,
      );
      newUsersList = state.getIn(['users', 'data']).toJS();
      newUsersList = newUsersList.map((user) => {
        if (user.id.toString() === action.userId) {
          return {
            ...user,
            modules: user.modules.filter(
              (module) => module.moduleID !== action.moduleId,
            ),
          };
        }
        return user;
      });
      newState = state.setIn(['users', 'data'], fromJS(newUsersList));
      return newState.setIn(['modules', 'data'], fromJS(newUserModules));

    case actions.USER_ROLES_FETCH_START:
      return state.setIn(['roles', 'state'], fetchingState.FETCHING);
    case actions.USER_ROLES_FETCH_SUCCESS:
      newState = state.setIn(['roles', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['roles', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.USER_ROLES_FETCH_ERROR:
      return state.setIn(['roles', 'state'], fetchingState.ERROR);

    case actions.USER_MODULE_ROLE_ADD_SUCCESS:
      let newUserRoles = state.getIn(['roles', 'data']).toJS();
      const newRole = action.data.results.find(
        (role) =>
          role.roleID === action.roleId && role.moduleID === action.moduleId,
      );
      newUserRoles = newUserRoles.concat([newRole]);
      newUsersList = state.getIn(['users', 'data']).toJS();
      newUsersList = newUsersList.map((user) => {
        if (user.id.toString() === action.userId) {
          const newRoles = user.roles ? user.roles : [];
          return {
            ...user,
            roles: newRoles.concat([newRole]),
          };
        }
        return user;
      });
      newState = state.setIn(['users', 'data'], fromJS(newUsersList));
      return newState.setIn(['roles', 'data'], fromJS(newUserRoles));

    case actions.USER_MODULE_ROLE_DELETE_SUCCESS:
      newUserRoles = state.getIn(['roles', 'data']).toJS();
      newUserRoles = newUserRoles.filter(
        (role) =>
          !(role.roleID === action.roleId && role.moduleID === action.moduleId),
      );
      newUsersList = state.getIn(['users', 'data']).toJS();
      newUsersList = newUsersList.map((user) => {
        if (user.id.toString() === action.userId) {
          let count = 0;
          return {
            ...user,
            roles: user.roles.filter((role) => {
              if (role.roleID === action.roleId) {
                if (count === 0) {
                  count++;
                  return false;
                }
                return true;
              }
              return true;
            }),
          };
        }
        return user;
      });
      newState = state.setIn(['users', 'data'], fromJS(newUsersList));
      return newState.setIn(['roles', 'data'], fromJS(newUserRoles));

    case actions.USER_UPDATE_SUCCESS:
      newUsersList = state.getIn(['users', 'data']).toJS();
      newUsersList = newUsersList.map((user) => {
        if (user.id === action.userId) {
          return {
            ...user,
            appraiserCd: action.userData.appraiserCd,
          };
        }
        return user;
      });
      return state.setIn(['users', 'data'], fromJS(newUsersList));

    case actions.TAXING_UNITS_FETCH_START:
      return state.setIn(['taxingUnits', 'state'], fetchingState.FETCHING);
    case actions.TAXING_UNITS_FETCH_SUCCESS:
      newState = state.setIn(['taxingUnits', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['taxingUnits', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.TAXING_UNITS_FETCH_ERROR:
      return state.setIn(['taxingUnits', 'state'], fetchingState.ERROR);

    case actions.USER_TAXING_UNITS_FETCH_START:
      return state.setIn(['userTaxingUnits', 'state'], fetchingState.FETCHING);
    case actions.USER_TAXING_UNITS_FETCH_SUCCESS:
      newState = state.setIn(
        ['userTaxingUnits', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['userTaxingUnits', 'data'],
        fromJS(
          action.data &&
            action.data.results &&
            action.data.results[0].taxingUnits
            ? action.data.results[0].taxingUnits
            : [],
        ),
      );
    case actions.USER_TAXING_UNITS_FETCH_ERROR:
      return state.setIn(['userTaxingUnits', 'state'], fetchingState.ERROR);

    case actions.USER_TAXING_UNITS_UPDATE_SUCCESS:
      newState = state.setIn(
        ['userTaxingUnits', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['userTaxingUnits', 'data'],
        fromJS(
          action.data && action.data.results
            ? action.data.results[0].userModuleConfig.taxingUnits
            : [],
        ),
      );

    case actions.USER_SEARCH_CRITERIA_FETCH_START:
      return state.setIn(['searchCriteria', 'state'], fetchingState.FETCHING);

    case actions.USER_SEARCH_CRITERIA_FETCH_SUCCESS:
      newState = state.setIn(['searchCriteria', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['searchCriteria', 'data'],
        fromJS(action.data.results),
      );

    case actions.USER_SEARCH_CRITERIA_FETCH_ERROR:
      return state.setIn(['searchCriteria', 'state'], fetchingState.ERROR);

    case actions.USER_ALL_TAXING_UNITS_FETCH_START:
      return state.setIn(['allTaxingUnits', 'state'], fetchingState.FETCHING);

    case actions.USER_ALL_TAXING_UNITS_FETCH_SUCCESS:
      newState = state.setIn(['allTaxingUnits', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['allTaxingUnits', 'data'],
        fromJS(action.data.results),
      );

    case actions.USER_ALL_TAXING_UNITS_FETCH_ERROR:
      return state.setIn(['allTaxingUnits', 'state'], fetchingState.ERROR);

    case actions.SEARCH_USERS_BY_FILTERS_START:
      return state.setIn(['filteredUsers', 'state'], fetchingState.FETCHING);

    case actions.SEARCH_USERS_BY_FILTERS_SUCCESS:
      newState = state.setIn(['filteredUsers', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['filteredUsers', 'total'],
        fromJS(action.data ? action.data.total[0].userCount : 0),
      );
      return newState.setIn(
        ['filteredUsers', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.SEARCH_USERS_BY_FILTERS_ERROR:
      return state.setIn(['filteredUsers', 'state'], fetchingState.ERROR);

    case actions.USER_DELETE_SUCCESS:
      newUsersList = state.getIn(['filteredUsers', 'data']).toJS();
      return state.setIn(
        ['filteredUsers', 'data'],
        fromJS(newUsersList.filter((u) => u.id !== action.userId)),
      );

    case actions.CLEAR_USER_SEARCH_LIST:
      return state.setIn(['filteredUsers', 'data'], fromJS([]));

    case actions.CLEAR_USER_TOTAL:
      return state.setIn(['filteredUsers', 'total'], fromJS(0));

    case actions.RESET_FILTERS:
      return state.setIn(['filters'], fromJS(initialFilterValues));

    case actions.UPDATE_FILTERS:
      const { name, value } = action.payload;
      return state.setIn(['filters', name], fromJS(value));

    case actions.GET_USER_SUMMARY_SUCCESS:
      const newItem = action.data.results[0];

      const indexToUpdate = state
        .getIn(['filteredUsers', 'data'])
        .findIndex((item) => item.get('id') === newItem.id);

      return state.setIn(
        ['filteredUsers', 'data', indexToUpdate],
        fromJS(newItem),
      );

    case actions.GET_USER_ATTRIBUTE_ASSOC[START]:
      return state.setIn(
        ['userAttributeAssocs', 'state'],
        fetchingState.FETCHING,
      );

    case actions.GET_USER_ATTRIBUTE_ASSOC[SUCCESS]:
      return state
        .setIn(['userAttributeAssocs', 'data'], fromJS(action.data.results))
        .setIn(['userAttributeAssocs', 'state'], fetchingState.LOADED);

    case actions.GET_USER_ATTRIBUTE_ASSOC[ERROR]:
      return state.setIn(['userAttributeAssocs', 'state'], fetchingState.ERROR);

    case actions.GET_SYSTEM_ATTRIBUTES[START]:
      return state.setIn(['systemAttributes', 'state'], fetchingState.FETCHING);

    case actions.GET_SYSTEM_ATTRIBUTES[SUCCESS]:
      return state
        .setIn(['systemAttributes', 'data'], fromJS(action.data.results))
        .setIn(['systemAttributes', 'state'], fetchingState.LOADED);

    case actions.GET_SYSTEM_ATTRIBUTES[ERROR]:
      return state.setIn(['systemAttributes', 'state'], fetchingState.ERROR);

    case actions.UPDATE_PAGE_FILTERS:
      return state.setIn(
        ['pageFilters', action.payload.name],
        fromJS(action.payload.value),
      );

    default:
      return state;
  }
};
